import { ElementRef, Injectable, Renderer2, RendererFactory2} from '@angular/core';
import { AuthenticationService } from '../_services/authentication.service';
import * as _ from "underscore"
import { environment } from '@environments/environment';
import { UntypedFormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { Annonce } from '../_models/annonce';
import { ComponentsModule } from '../_components/components.module';
import { BehaviorSubject, Observable } from 'rxjs';
import { user } from '../_models/user';
declare var INSPIRO;

@Injectable({
  providedIn: 'root'
})
export class GlobalHelper {

  renderer
  currentUser:user;
  subscriptions:any = [];

  scanReady = false;
  panier = [];

statutOccupantList = [

  'Hébergé au domicile parental',
  'Habite en HLM',
  'Habite dans un logement privé',
  'Habite en colocation',
  'Hébergé par des amis',
  'Habite dans un foyer de jeunes travailleurs',
  'Habite en internat',
  'Habite dans un hébergement d’urgence, CHRS ou résidence sociale',
  'Squat']




motivationList = [
'Recherche d’autonomie',
  'Rapprochement géographique',
  'Retour au pays/Mobilité',
  'Evolution de situation familiale',
  'Location actuelle inadaptée',
  'Autre']

  typeLogementList = [

    'chambre chez l\'habitant',
    'chambre en colocation',
    'Studio',
    'F1',
    'F2',
    'F3',
    'F4',
    'F5',
    'F6',
    'Foyer pension']

  civiliteList = [
    'Madame','Monsieur'
    ]
    situationproList = [
      'CDD (Contrat aidé ...)',
      'CDI',
      "Contrat d'avenir",
      'CUI',
      'CAE DOM',
      'Intérimaire',
      "Demandeur d'emploi : inscrit pôle emploi ou mission locale",
      'Etudiant : Prépa, IFMES, BTS, école, boursier, irav ...',
      'Scolaire',
      'En formation',
      'Sans emploi : non inscrit pôle emploi',
      'Travailleur indépendant : créateur entreprise, artisan',
      "Travailleur porteur d'un handicape",
      'Apprentis',
      'TTS (Titre de travail simplifié)',
      'Contrat volontaire ( RSMA, Service civique ...)',
      'Garanties proprietaires',
      'Autre',
    ];
    situationfamiList = [
      'Célibataire',
      'Pacsé(e)',
      'Célibataire avec enfant(s)',
      'Marié(e)',
      'Couple',
      'Couple avec enfants',
      'Séparé(e)',
      'Instance de divorce',
      'Divorcé(e)',
      'Veuf/ve'
    ];
    mediaList = [
      'Les médias',
      'Internet',
      'Une manifestation',
      'Le Forum Dclic Logement',
      'La mission locale',
      'Un ou une amie',
      'Un service social',
      'Mon employeur',
      'Un autre CLLAJ',
      'Mon établissement',
      'Autre'
    ];
    loueurList = [
      'Propriétaire',
      'SCI',
      'Agence immobilière',
      'Mandataire'
    ]
    territoireList = [
      {
        name: 'Martinique',
        villes: [
          { name: 'Ajoupa Bouillon', adresse2s: [
                        {name:"Abandonne"},
                        {name:"Adinet"},
                        {name:"Bourg"},
                        {name:"Centre ville"},
                        {name:"Croix Laurence"},
                        {name:"Deschamps"},
                        {name:"Dufailly"},
                        {name:"Grande Savane"},
                        {name:"la Capote"},
                        {name:"la Racine"},
                        {name:"Mille Pas"},
                        {name:"Mondzi"},
                        {name:"Ravine des Saints"},
                        {name:"Rosalie"},
                        {name:"Semaine"},
                        {name:"Sence"},
                        {name:"Vieux Cacao"},
                        {name:"Autre"},
          ] },
          { name: 'Basse Pointe', adresse2s: [
                        {name :"Bourg"},
                        {name :"Centre ville"},
                        {name :"Chalvet"},
                        {name :"Eyma"},
                        {name :"Hackaert"},
                        {name :"Hauteur bourbon"},
                        {name :"Hauteur Dumas"},
                        {name :"La falaise"},
                        {name :"La lave"},
                        {name :"Magdelonnette"},
                        {name :"Moulin l'etang"},
                        {name :"Pecoul"},
                        {name :"Potiche"},
                        {name:"Autre"},

          ] },
          { name: 'Bellefontaine', adresse2s: [
                    {name:"Bois Desir"},
                    {name:"Bourg"},
                    {name:"Canal"},
                    {name:"Centre ville"},
                    {name:"Cheval Blanc"},
                    {name:"Duvallon"},
                    {name:"Fond laillet"},
                    {name:"Fourcher"},
                    {name:"Jeannot"},
                    {name:"morne roches"},
                    {name:"Verrier"},
                    {name:"Autre"},
          ] },
          { name: 'Case Pilote', adresse2s: [
                    {name:"Batterie"},
                    {name:"Bourg"},
                    {name:"Case Brulee"},
                    {name:"Centre ville"},
                    {name:"Choiseul"},
                    {name:"Fond boucher"},
                    {name:"fond bourlet"},
                    {name:"fourniol"},
                    {name:"Grande trace"},
                    {name:"haut de maniba"},
                    {name:"La demarche"},
                    {name:"Les abymes"},
                    {name:"Maniba"},
                    {name:"micolo"},
                    {name:"Morne acajou"},
                    {name:"Morne Capot"},
                    {name:"Morne obely"},
                    {name:"Plaisance"},
                    {name:"Autre"},
          ] },
          { name: 'Ducos', adresse2s: [
                    {name:"Baie des Mulets"},
                    {name:"Barrington"},
                    {name:"beauville"},
                    {name:"Bourg"},
                    {name:"Canal"},
                    {name:"Centre ville"},
                    {name:"Chemin de Fer"},
                    {name:"citron"},
                    {name:"Dallas"},
                    {name:"Durivage"},
                    {name:"Fenelon"},
                    {name:"Fond bruler"},
                    {name:"fond d'orange"},
                    {name:"Fond savane"},
                    {name:"Genipa"},
                    {name:"Grande rochelle"},
                    {name:"Grande savane"},
                    {name:"La beauville"},
                    {name:"LA body"},
                    {name:"La cadeau"},
                    {name:"La chaissing"},
                    {name:"La cheneaux"},
                    {name:"La leandre"},
                    {name:"la marie"},
                    {name:"La Regale"},
                    {name:"La roman"},
                    {name:"Lazaret"},
                    {name:"Le repos"},
                    {name:"Lourdes"},
                    {name:"morne carette"},
                    {name:"Morne Coco"},
                    {name:"Morne lapointe"},
                    {name:"Morne vert"},
                    {name:"Pays noye"},
                    {name:"Petit paradis"},
                    {name:"Petit parc"},
                    {name:"Petite Cocotte"},
                    {name:"Petite rochelle"},
                    {name:"Pignol"},
                    {name:"Riviere pierre"},
                    {name:"Saint pierre"},
                    {name:"Syndic"},
                    {name:"Vaudrancourt"},
                    {name:"Vert pré"},
                    {name:"ZAC du bac"},
                    {name:"Autre"},

          ] },
          { name: 'Fonds Saint Denis', adresse2s: [
                    {name:"Bourg"},
                    {name:"Morne des Cadets"},
                    {name:"Autre"},
          ] },
          { name: 'Fort de France', adresse2s: [
                    {name:"Absalon"},
                    {name:"Ancienne route de schoelcher"},
                    {name:"Avenue Maurice Bishop"},
                    {name:"Baie des Tourelles"},
                    {name:"Balata "},
                    {name:"bareme"},
                    {name:"Bas maternité"},
                    {name:"Bellevue"},
                    {name:"berge debriand"},
                    {name:"bois boyer"},
                    {name:"bois thibault"},
                    {name:"bon air"},
                    {name:"Bourg"},
                    {name:"Bª kannal"},
                    {name:"Calvaire"},
                    {name:"Canal Alaric"},
                    {name:"Centre Ville"},
                    {name:"Centre ville"},
                    {name:"Chateauboeuf"},
                    {name:"cite bonaire"},
                    {name:"cité calebasse"},
                    {name:"cité dillon"},
                    {name:"Cité ozanam"},
                    {name:"citron"},
                    {name:"clairiere"},
                    {name:"clemenceau"},
                    {name:"cluny"},
                    {name:"Colson"},
                    {name:"coridon"},
                    {name:"Cour campeche"},
                    {name:"crozanville"},
                    {name:"Dallas"},
                    {name:"Debriant"},
                    {name:"Desaix"},
                    {name:"Desbrosses"},
                    {name:"Desbrosses Tivoli"},
                    {name:"Desclieux"},
                    {name:"Descossieres"},
                    {name:"desrochers"},
                    {name:"didier"},
                    {name:"dillon"},
                    {name:"Dillon Nord"},
                    {name:"Dillon Sud"},
                    {name:"eaux  découpées"},
                    {name:"entraide"},
                    {name:"ermitage"},
                    {name:"Etang z'abricot"},
                    {name:"Fantaisie"},
                    {name:"Faubourg la Camille"},
                    {name:"Floreal"},
                    {name:"Fond comat"},
                    {name:"Fond Lada"},
                    {name:"Godissard"},
                    {name:"grosse roche"},
                    {name:"hauts du port"},
                    {name:"Jambette"},
                    {name:"jambette 2"},
                    {name:"Jules Beaunes Tivoli"},
                    {name:"KERLYS"},
                    {name:"La Carrire"},
                    {name:"la folie"},
                    {name:"La Médaille"},
                    {name:"La Meynard"},
                    {name:"Langellier"},
                    {name:"martin Luther King"},
                    {name:"Montgerald"},
                    {name:"Morne calebasse"},
                    {name:"Morne dillon"},
                    {name:"Morne laurent Tivoli"},
                    {name:"Morne morissot"},
                    {name:"Morne Pichevin"},
                    {name:"morne vannier"},
                    {name:"Morne Vente"},
                    {name:"moutte"},
                    {name:"pavé"},
                    {name:"Petite Cocotte"},
                    {name:"petite zac"},
                    {name:"Plateau Fofo est"},
                    {name:"plateau tiberge"},
                    {name:"pointe de la vierge"},
                    {name:"pointe des carriers"},
                    {name:"Pointe Des Grives"},
                    {name:"pointe des ngres"},
                    {name:"pointe simon"},
                    {name:"pont de chaines"},
                    {name:"Pont viard"},
                    {name:"Populo"},
                    {name:"Post Colon"},
                    {name:"Post colon tivoli"},
                    {name:"ravine blanche"},
                    {name:"ravine bouillée"},
                    {name:"ravine vilaine"},
                    {name:"redoute"},
                    {name:"renéville"},
                    {name:"Reunion"},
                    {name:"Rive droite levassor"},
                    {name:"rivire l'or"},
                    {name:"Rivire roche"},
                    {name:"rodate"},
                    {name:"Rodate tivoli"},
                    {name:"route de balata"},
                    {name:"Route de la folie"},
                    {name:"route de moutte"},
                    {name:"Route des religieuse"},
                    {name:"Sainte Catherine"},
                    {name:"Sainte therese"},
                    {name:"Tartenson"},
                    {name:"Terres Sainville"},
                    {name:"Texaco"},
                    {name:"tivoli"},
                    {name:"Toquade"},
                    {name:"Tourtet"},
                    {name:"TRENELLE"},
                    {name:"TSF Canal Alaric"},
                    {name:"vieux moulin"},
                    {name:"voix de ville"},
                    {name:"volga plage"},
                    {name:"volga sud"},
                    {name:"zac chateauboeuf"},
                    {name:"zac de l'etang z'abricot"},
                    {name:"ZAC de rivire roche"},
                    {name:"zac est"},
                    {name:"Autre"},


          ] },
          { name: 'Grand Rivière', adresse2s: [
            {name:"Bourg"},
            {name:"Autre"},] },
          { name: 'Gros Morne', adresse2s: [
                    {name:"Bagatelle"},
                    {name:"Bas 2 Terres"},
                    {name:"Belle Terre"},
                    {name:"bois l_zarde"},
                    {name:"Bourg"},
                    {name:"Calvaire"},
                    {name:"Centre ville"},
                    {name:"Cote d'or"},
                    {name:"croix girin"},
                    {name:"Croix jubile"},
                    {name:"Croix odillon"},
                    {name:"Denel"},
                    {name:"Dessaint"},
                    {name:"Deux terres"},
                    {name:"dominant"},
                    {name:"Dosithee"},
                    {name:"Dumaine"},
                    {name:"glotin"},
                    {name:"Hauteur Four A Chaux"},
                    {name:"La birot"},
                    {name:"La fraicheur"},
                    {name:"La nazaire"},
                    {name:"La tracee"},
                    {name:"La vierge"},
                    {name:"Les flamboyants"},
                    {name:"Magnan"},
                    {name:"Petite lezarde"},
                    {name:"Providence"},
                    {name:"ravine plate"},
                    {name:"Riviere lezarde 1"},
                    {name:"RIViviere lezarde 2"},
                    {name:"rivire pomme"},
                    {name:"SINAI"},
                    {name:"Tamarins"},
                    {name:"Autre"},
          ] },
          { name: 'La Trinité', adresse2s: [
                    {name:"Anse Belgrade"},
                    {name:"Anse Bellune"},
                    {name:"Anse l'Etang"},
                    {name:"Anse Spourtourne"},
                    {name:"Bac"},
                    {name:"Bagatelle"},
                    {name:"Bassignac"},
                    {name:"Bassignac"},
                    {name:"Beauséjour"},
                    {name:"Bocage"},
                    {name:"Bonneville"},
                    {name:"Bourg"},
                    {name:"Brevette"},
                    {name:"Brin d'Amour"},
                    {name:"Canal"},
                    {name:"Centre ville"},
                    {name:"Cosmy"},
                    {name:"Croix Guy"},
                    {name:"Degras"},
                    {name:"Descossieres"},
                    {name:"Desforts"},
                    {name:"Desmarinieres"},
                    {name:"Dijon"},
                    {name:"Doudou"},
                    {name:"Dufferret"},
                    {name:"Epinette"},
                    {name:"Ferret"},
                    {name:"Fond Bazile"},
                    {name:"Fonds Galion"},
                    {name:"Galion"},
                    {name:"Galion"},
                    {name:"Gergault"},
                    {name:"la Breche"},
                    {name:"la Camille"},
                    {name:"la Colline"},
                    {name:"la Crique"},
                    {name:"la Flotille"},
                    {name:"la Moise"},
                    {name:"les Dominants"},
                    {name:"Les Hauts"},
                    {name:"L'Autre Bord"},
                    {name:"l'autre bord"},
                    {name:"Malgre Tout"},
                    {name:"Maximin"},
                    {name:"Merveilleuse"},
                    {name:"Morne Figue"},
                    {name:"Morne Poirier"},
                    {name:"Petit Galion"},
                    {name:"Petite Rivière Salee"},
                    {name:"Plaisable"},
                    {name:"Poirier"},
                    {name:"Raisinier"},
                    {name:"Ressource"},
                    {name:"Tartane"},
                    {name:"tracée"},
                    {name:"Tracee Bonnin"},
                    {name:"Val Beausejour"},
                    {name:"Autre"},
          ] },
          { name: 'Le Carbet', adresse2s: [
                      {name:"Anse Latouche"},
                      {name:"Bel Event"},
                      {name:"belfond"},
                      {name:"Bourg"},
                      {name:"Bout Bois"},
                      {name:"Centre ville"},
                      {name:"Dariste"},
                      {name:"Duvallon"},
                      {name:"fond bourlet"},
                      {name:"Four"},
                      {name:"Godinot"},
                      {name:"Gros Coulirous"},
                      {name:"la Berlin"},
                      {name:"la Cafeiere"},
                      {name:"Lajus 1"},
                      {name:"Lajus 2"},
                      {name:"Lajus 3"},
                      {name:"le Coin"},
                      {name:"le Fromager"},
                      {name:"le Trou"},
                      {name:"Longvillier"},
                      {name:"Morne Aux Boeufs"},
                      {name:"Morne Gabillon"},
                      {name:"Petite Rivire"},
                      {name:"Autre"},
    ] },
          { name: 'Le Diamant', adresse2s: [
                    {name:"Ancinel"},
                    {name:"Anse Caffard"},
                    {name:"Artisanal de Taupiniere"},
                    {name:"Bitaille"},
                    {name:"Bonne Terre"},
                    {name:"Bourg"},
                    {name:"Carole"},
                    {name:"Centre ville"},
                    {name:"Chalopin"},
                    {name:"Dizac"},
                    {name:"Fond Camille"},
                    {name:"Fond Manoel"},
                    {name:"Fond Placide"},
                    {name:"Haut Morne"},
                    {name:"Jacqua"},
                    {name:"Jeanville"},
                    {name:"Joubadiere"},
                    {name:"la Cherry"},
                    {name:"la Melise"},
                    {name:"la Pointe"},
                    {name:"le Gaoule"},
                    {name:"Longuet"},
                    {name:"Mare Poirier"},
                    {name:"Morne Blanc"},
                    {name:"Morne Constant"},
                    {name:"Morne la Croix"},
                    {name:"Morne Pavillon"},
                    {name:"O Mullane"},
                    {name:"Petit Lezard"},
                    {name:"Quamalon"},
                    {name:"Ravine Gens Bois"},
                    {name:"Tamarin"},
                    {name:"Thoraille"},
              {name:"Autre"},

          ] },
          { name: 'Le Francois', adresse2s: [
                    {name:"2 Courants"},
                    {name:"Beauregard"},
                    {name:"Belle Ame"},
                    {name:"Bellegarde"},
                    {name:"Bois Soldat"},
                    {name:"Bonny"},
                    {name:"Bourg"},
                    {name:"Canal"},
                    {name:"Cap Est"},
                    {name:"Centre ville"},
                    {name:"Chapelle Villarson"},
                    {name:"Chopotte"},
                    {name:"Chopotte 1"},
                    {name:"Chopotte 2"},
                    {name:"Chopotte 3"},
                    {name:"Cotonnerie"},
                    {name:"Croix Pelage"},
                    {name:"Desroses"},
                    {name:"Dostaly"},
                    {name:"Dupuis"},
                    {name:"Fregate"},
                    {name:"Gabourin"},
                    {name:"Grand Fond"},
                    {name:"Hauteur Bellevue"},
                    {name:"la Francisque"},
                    {name:"la Haut"},
                    {name:"la Manzo"},
                    {name:"Magdelonnette"},
                    {name:"Mena"},
                    {name:"Morne acajou"},
                    {name:"Morne Courbaril"},
                    {name:"Morne Gamelle"},
                    {name:"Morne la Croix"},
                    {name:"Morne l'Estomac"},
                    {name:"Morne Pavillon"},
                    {name:"Morne Pitault"},
                    {name:"Otier"},
                    {name:"Perriolat 1"},
                    {name:"Perriolat 2"},
                    {name:"Perriolat 3"},
                    {name:"Petite France"},
                    {name:"pointe coucher"},
                    {name:"Pointe Courchet Nord"},
                    {name:"Pointe Thalemont"},
                    {name:"Presqu Ile"},
                    {name:"Rivire Bambou"},
                    {name:"Saint Laurent"},
                    {name:"Saint Laurent Bicetre"},
                    {name:"Saint Roch"},
                    {name:"Trianon"},
                    {name:"Vapeur"},
              {name:"Autre"},

          ] },
          { name: 'Le Lamentin', adresse2s: [
                    {name:"Acajou"},
                    {name:"Acajou Est"},
                    {name:"Acajou Nord"},
                    {name:"Acajou Ouest"},
                    {name:"Acajou Sud"},
                    {name:"Autoroute Césaire"},
                    {name:"Bas 2 Terres"},
                    {name:"Bas mission"},
                    {name:"Basse Gondeau"},
                    {name:"Bel Air"},
                    {name:"Bélème"},
                    {name:"Belfort"},
                    {name:"Belle Isle"},
                    {name:"Bellonie"},
                    {name:"Bochette"},
                    {name:"bois d'inde"},
                    {name:"Bois Neuf"},
                    {name:"bois quarré"},
                    {name:"bois rouge"},
                    {name:"Bourg"},
                    {name:"bourg"},
                    {name:"Brachet"},
                    {name:"Briere L'Isle"},
                    {name:"Calebassier"},
                    {name:"californie"},
                    {name:"Canal"},
                    {name:"Carrere"},
                    {name:"Centre ville"},
                    {name:"Chambord"},
                    {name:"croix rivail"},
                    {name:"Daubert"},
                    {name:"Durocher"},
                    {name:"Duschene 2"},
                    {name:"Duschene1"},
                    {name:"Floraindre"},
                    {name:"Fond bellemare"},
                    {name:"Fond coitron"},
                    {name:"Haute Gondeau"},
                    {name:"Hotel des plaisirs"},
                    {name:"jeanne d'arc"},
                    {name:"La ressource"},
                    {name:"La trompeuse"},
                    {name:"lareinty"},
                    {name:"long pré"},
                    {name:"Mahault"},
                    {name:"Mangot vulcin"},
                    {name:"Manzelle"},
                    {name:"Mont Vert"},
                    {name:"Monteol"},
                    {name:"morne carette"},
                    {name:"morne roches"},
                    {name:"Morne Serpent"},
                    {name:"Otier"},
                    {name:"Palmiste"},
                    {name:"Patit bambou"},
                    {name:"territoire mélés"},
                    {name:"Pelletier"},
                    {name:"petit manoir"},
                    {name:"Petit morne"},
                    {name:"petit paradis"},
                    {name:"Petite riviere"},
                    {name:"Place d'armes"},
                    {name:"Plaisance"},
                    {name:"Pointe Jean Claude"},
                    {name:"Rives chancel"},
                    {name:"Riviere calecon"},
                    {name:"roche carré"},
                    {name:"Sarrault"},
                    {name:"Savane dede"},
                    {name:"Soudon"},
                    {name:"Trenelle"},
                    {name:"Union"},
                    {name:"Vert pré"},
                    {name:"vieux pont"},
              {name:"Autre"},

          ] },
          { name: 'Le Lorrain', adresse2s: [
                    {name:"Assier"},
                    {name:"Bas Ceron"},
                    {name:"Bn Repos"},
                    {name:"Bourg"},
                    {name:"Carabin"},
                    {name:"Carabin Bas"},
                    {name:"Centre ville"},
                    {name:"Crochemort"},
                    {name:"Etoile"},
                    {name:"Fonds Brule"},
                    {name:"Fonds Cany"},
                    {name:"Fonds Gens Libres"},
                    {name:"Fonds Grand Anse"},
                    {name:"Fonds Labour"},
                    {name:"Grosse Roche"},
                    {name:"Guerin"},
                    {name:"Macedoine"},
                    {name:"Maxime"},
                    {name:"Moreau"},
                    {name:"Morne Capot"},
                    {name:"Morne Ceron"},
                    {name:"Morne Ceron 1"},
                    {name:"Morne Ceron 2"},
                    {name:"Morne Savon"},
                    {name:"Pavillon"},
                    {name:"Redoute"},
                    {name:"Rivire Claire"},
                    {name:"Seguineau"},
                    {name:"Sous Bois"},
                    {name:"vallon"},
                    {name:"Vive"},
              {name:"Autre"},

          ] },
          { name: 'Le Marigot', adresse2s: [
                    {name:"Baignoire"},
                    {name:"Bourg"},
                    {name:"Centre ville"},
                    {name:"Charpentier"},
                    {name:"dominante"},
                    {name:"Dorival"},
                    {name:"Garane"},
              {name:"Autre"},

          ] },
          { name: 'Le Marin', adresse2s: [
                    {name:"Bourg"},
                    {name:"Cap beauchne"},
                    {name:"Centre ville"},
                    {name:"La agns"},
                    {name:"La berry"},
                    {name:"La Sulpice"},
                    {name:"morne gommier"},
              {name:"Autre"},

          ] },
          { name: 'Le Morne Rouge', adresse2s: [
                    {name:"Abdelkader"},
                    {name:"Balisier"},
                    {name:"Bourg"},
                    {name:"Centre ville"},
                    {name:"Chamonix"},
                    {name:"Champflore"},
                    {name:"des Grosses Roches"},
                    {name:"du Val Joli"},
                    {name:"fond marie reine"},
                    {name:"Fond Rose"},
                    {name:"Mespont"},
                    {name:"Proprete"},
                    {name:"Savane Petit"},
                    {name:"Zobeide"},
              {name:"Autre"},

          ] },
          { name: 'Le Morne Vert', adresse2s: [
                    {name:"Beauvalon"},
                    {name:"Bel Event"},
                    {name:"Bel Event 2"},
                    {name:"Bernadette"},
                    {name:"Bois Lezard"},
                    {name:"Bourg"},
                    {name:"Bout Barriere"},
                    {name:"Canton Suisse"},
                    {name:"Caplet"},
                    {name:"Centre Ville"},
                    {name:"Chateau"},
                    {name:"Fonds d'Or"},
                    {name:"Jean"},
                    {name:"Jolimont"},
                    {name:"la Croix"},
                    {name:"la Vigie"},
                    {name:"Mont Joly"},
                    {name:"Petite Rivière"},
                    {name:"Rivière Coco"},
                    {name:"Saint Maurice"},
                    {name:"Urion"},
                    {name:"Vaudrin"},
              {name:"Autre"},

          ] },
          { name: 'Le Prêcheur', adresse2s: [
                    {name:"Anse Belleville"},
                    {name:"Anse Ceron"},
                    {name:"Anse Couleuvre"},
                    {name:"Batiment Chelonia"},
                    {name:"Boisville"},
                    {name:"Bourg"},
                    {name:"Bourg"},
                    {name:"Calle des Marches"},
                    {name:"Centre Ville"},
                    {name:"Corido Man Coya"},
                    {name:"Corido Mayotte"},
                    {name:"Espace Samboura"},
                    {name:"Four A Chaux"},
                    {name:"Le Plan d'Eau"},
                    {name:"Les Abymes"},
                    {name:"Pointe Lamarre"},
                    {name:"Wet Bassignac"},
                    {name:"Wet Becune"},
                    {name:"Wet Dorade"},
                    {name:"Wet la Batterie"},
                    {name:"Wet Melon"},
                    {name:"Wet Momone"},
                    {name:"Wet Pory Papi"},
                    {name:"Wet Rele"},
                    {name:"Wet Sandopi"},
                    {name:"Wet Vare"},
                    {name:"Wet Zofi"},
              {name:"Autre"},

          ] },
          { name: 'Le Robert', adresse2s: [
                    {name:"Augrain"},
                    {name:"Augrain Nord"},
                    {name:"Augrain Sud"},
                    {name:"Bellay"},
                    {name:"Berthou"},
                    {name:"Bois Desir"},
                    {name:"Bois du parc"},
                    {name:"Bois Neuf"},
                    {name:"Bois Potheau"},
                    {name:"Bois Zombi"},
                    {name:"Bonneau"},
                    {name:"Bourg"},
                    {name:"Boutaud"},
                    {name:"Bresson"},
                    {name:"Brice"},
                    {name:"Cafe"},
                    {name:"Cannelle"},
                    {name:"Centre ville"},
                    {name:"Chamfleury"},
                    {name:"Chere Epice"},
                    {name:"Cite Lacroix"},
                    {name:"Coulisse Mignot"},
                    {name:"Coulisse Mont Vert"},
                    {name:"Duchene"},
                    {name:"ermitage"},
                    {name:"Fond Brule"},
                    {name:"Fond Cacao"},
                    {name:"Fond Duchene"},
                    {name:"Fond d'Or"},
                    {name:"Galette"},
                    {name:"Gaschette"},
                    {name:"Hauteur Fond Nicolas"},
                    {name:"Hauteur Four A Chaux"},
                    {name:"Hauteur Pontalery"},
                    {name:"La birot"},
                    {name:"la Cadet"},
                    {name:"la Charles"},
                    {name:"la Digue"},
                    {name:"la Dirozo"},
                    {name:"la Moise"},
                    {name:"Lacroix"},
                    {name:"Lazaret"},
                    {name:"Lecomte"},
                    {name:"Lestrade"},
                    {name:"l'Heureux"},
                    {name:"Mansarde catalogne"},
                    {name:"Mansarde rancée"},
                    {name:"Marlet"},
                    {name:"Mena"},
                    {name:"Monnerot"},
                    {name:"Mont Vert"},
                    {name:"Morne Galbas"},
                    {name:"Moulin A Vent"},
                    {name:"Pointe Fort"},
                    {name:"Pointe Hyacinthe"},
                    {name:"Pointe Jean Claude"},
                    {name:"Pointe la Rose"},
                    {name:"Pointe Lynch"},
                    {name:"Pointe Rouge"},
                    {name:"Pointe Royale"},
                    {name:"pointe savane"},
                    {name:"Pontalery"},
                    {name:"Providence"},
                    {name:"Raisin"},
                    {name:"Reunion"},
                    {name:"Reynoird"},
                    {name:"Sabine"},
                    {name:"Sable Blanc"},
                    {name:"Saint Christophe"},
                    {name:"Trou Terre"},
                    {name:"Vert pré"},
                    {name:"Voltaire"},
                    {name:"Yoyoye"},
                    {name:"Zabeth"},
              {name:"Autre"},

          ] },
          { name: 'Le Vauclin', adresse2s: [
                    {name:"Baie des Mulets"},
                    {name:"Beaujolais"},
                    {name:"Belle Etoile"},
                    {name:"Bellevue"},
                    {name:"Benguette"},
                    {name:"Boe"},
                    {name:"Bourg"},
                    {name:"Cadette"},
                    {name:"Cambeilh"},
                    {name:"Carrire"},
                    {name:"Centre ville"},
                    {name:"Chamfleury"},
                    {name:"Chateau d'Eau"},
                    {name:"Coq"},
                    {name:"Coulee d'Or"},
                    {name:"Dessaint"},
                    {name:"Ducassous"},
                    {name:"Dunoyer"},
                    {name:"Ensfelder"},
                    {name:"Escarvaille"},
                    {name:"Fond Zamy"},
                    {name:"Fonds Mulatre"},
                    {name:"Four"},
                    {name:"Goujon"},
                    {name:"Grand Boucan"},
                    {name:"haut de maniba"},
                    {name:"Humbert"},
                    {name:"la Broue"},
                    {name:"la Ferme"},
                    {name:"la Montagn"},
                    {name:"l'Union"},
                    {name:"Macabou"},
                    {name:"Malveaux"},
                    {name:"Mont Vert"},
                    {name:"Morne Carrire"},
                    {name:"Morne la Croix"},
                    {name:"Morne Raquette"},
                    {name:"Neveu"},
                    {name:"Paquemar"},
                    {name:"Petit Campeche"},
                    {name:"Petit Perou"},
                    {name:"Petite Grenade"},
                    {name:"Petite Ravine"},
                    {name:"Placide"},
                    {name:"Pointe Athanase"},
                    {name:"Pointe Chaudiere"},
                    {name:"Pointe Faula"},
                    {name:"Puyferrat"},
                    {name:"ravine plate"},
                    {name:"Sans Souci"},
                    {name:"Sigy"},
              {name:"Autre"},

          ] },
          { name: "Les Anses d'Arlet", adresse2s: [
                    {name:"Anse Chaudière"},
                    {name:"Anse d'arlet"},
                    {name:"Anse Dufour"},
                    {name:"Anse Noire"},
                    {name:"Batterie"},
                    {name:"Bourg"},
                    {name:"Casin"},
                    {name:"Cassiere"},
                    {name:"Cocoyers"},
                    {name:"Coin Bananes"},
                    {name:"Coin des Peres"},
                    {name:"Flandrin"},
                    {name:"Fond Fleury"},
                    {name:"Gallochat"},
                    {name:"Grande Anse"},
                    {name:"l'Etang"},
                    {name:"La Plaine"},
                    {name:"Maleau"},
                    {name:"Mapou"},
                    {name:"Medelice"},
                    {name:"Morne Bigot"},
                    {name:"Morne Gentil"},
                    {name:"Morne Jacqueline"},
                    {name:"Palmiste"},
                    {name:"Petit Anse"},
                    {name:"Séjourner"},
                    {name:"Zaire"},
              {name:"Autre"},

          ] },
          { name: 'Les Trois Ilets', adresse2s: [
                    {name:"Anse a l'ane"},
                    {name:"Anse Mitan"},
                    {name:"Beaufond"},
                    {name:"Bigotte"},
                    {name:"Bourg"},
                    {name:"Centre ville"},
                    {name:"Charles Pieds"},
                    {name:"ChEteau Gaillard"},
                    {name:"Concorde"},
                    {name:"Desloges"},
                    {name:"Fond Fleury"},
                    {name:"Glacy"},
                    {name:"la Capoul"},
                    {name:"la Clouette"},
                    {name:"la Debat"},
                    {name:"la Pagerie"},
                    {name:"la Source"},
                    {name:"Magasin Zeline"},
                    {name:"Morne Bigot"},
                    {name:"Morne Vent"},
                    {name:"Papias"},
                    {name:"Phaeton"},
                    {name:"Pointe du bout"},
                    {name:"Pointe Etienne"},
                    {name:"Pointe Vatable"},
                    {name:"Poterie"},
                    {name:"Radar"},
                    {name:"Rateau"},
                    {name:"Sarcelle"},
                    {name:"Thomas"},
                    {name:"Vatable"},
                    {name:"Wallon"},
              {name:"Autre"},

          ] },
          { name: 'Macouba', adresse2s: [
                    {name:"Bellevue"},
                    {name:"Bourg"},
                    {name:"Centre Ville"},
                    {name:"Cheneaux"},
                    {name:"Guerin"},
                    {name:"Perpigna"},
                    {name:"Potiche"},
                    {name:"Terre Patate"},
              {name:"Autre"},

          ] },
          { name: 'Rivière Pilote', adresse2s: [
                    {name:"Abondance"},
                    {name:"Anse Figuier"},
                    {name:"Bas Mangots"},
                    {name:"Baudelle"},
                    {name:"Beauregard Cafeiere"},
                    {name:"Beauregard Sucriere"},
                    {name:"Bellay"},
                    {name:"Bonne Terre"},
                    {name:"Borel"},
                    {name:"Bourg"},
                    {name:"Canari Casse"},
                    {name:"Centre ville"},
                    {name:"Chevalier"},
                    {name:"Cocoyers"},
                    {name:"Coulanges"},
                    {name:"Croix Godet"},
                    {name:"Derriere Morne"},
                    {name:"Desfarges"},
                    {name:"Desruisseaux"},
                    {name:"En Bellay"},
                    {name:"En Brie"},
                    {name:"Escarvaille"},
                    {name:"fond bourlet"},
                    {name:"Fond Mulatre"},
                    {name:"Gervais"},
                    {name:"Josseaud"},
                    {name:"la Beaume"},
                    {name:"la Debat"},
                    {name:"la Faveur"},
                    {name:"La Regale"},
                    {name:"la Renee"},
                    {name:"Lourdes"},
                    {name:"Lowinsky"},
                    {name:"l'Escouet"},
                    {name:"Mare Capron"},
                    {name:"Marianne"},
                    {name:"Marie Noire"},
                    {name:"Massonville"},
                    {name:"Mathurin"},
                    {name:"Mauny"},
                    {name:"Mauny Concorde"},
                    {name:"Mayol"},
                    {name:"Montplaisir"},
                    {name:"Morency"},
                    {name:"Morne Abricot"},
                    {name:"Morne Escarpe"},
                    {name:"Morne Honore"},
                    {name:"Morne Pavillon"},
                    {name:"Morne Roches"},
                    {name:"Morne Vent"},
                    {name:"Pain Bis"},
                    {name:"Perrine"},
                    {name:"Petit Coton"},
                    {name:"Plat Peyi"},
                    {name:"Poirier"},
                    {name:"Pomare"},
                    {name:"Pont Madeleine"},
                    {name:"Prefontaine"},
                    {name:"Ravine Acajou"},
                    {name:"Ravine Braie"},
                    {name:"Regale"},
                    {name:"Regale Renee"},
                    {name:"Rivage"},
                    {name:"Rodalie"},
                    {name:"Rollin"},
                    {name:"Saint Pont"},
                    {name:"Saint Vincent"},
                    {name:"Vieille Citerne"},
                    {name:"Vieilles Terres"},
                    {name:"Vignette"},
              {name:"Autre"},

          ] },
          { name: 'Rivière Salée', adresse2s: [
                    {name:"Abondance"},
                    {name:"Anse Figuier"},
                    {name:"Bas Mangots"},
                    {name:"Baudelle"},
                    {name:"Beauregard Cafeiere"},
                    {name:"Beauregard Sucriere"},
                    {name:"Bellay"},
                    {name:"Bonne Terre"},
                    {name:"Borel"},
                    {name:"Bourg"},
                    {name:"Canari Casse"},
                    {name:"Centre ville"},
                    {name:"Chevalier"},
                    {name:"Cocoyers"},
                    {name:"Coulanges"},
                    {name:"Croix Godet"},
                    {name:"Derriere Morne"},
                    {name:"Desfarges"},
                    {name:"Desruisseaux"},
                    {name:"En Bellay"},
                    {name:"En Brie"},
                    {name:"Escarvaille"},
                    {name:"fond bourlet"},
                    {name:"Fond Mulatre"},
                    {name:"Gervais"},
                    {name:"Josseaud"},
                    {name:"la Beaume"},
                    {name:"la Debat"},
                    {name:"la Faveur"},
                    {name:"La Regale"},
                    {name:"la Renee"},
                    {name:"Lourdes"},
                    {name:"Lowinsky"},
                    {name:"l'Escouet"},
                    {name:"Mare Capron"},
                    {name:"Marianne"},
                    {name:"Marie Noire"},
                    {name:"Massonville"},
                    {name:"Mathurin"},
                    {name:"Mauny"},
                    {name:"Mauny Concorde"},
                    {name:"Mayol"},
                    {name:"Montplaisir"},
                    {name:"Morency"},
                    {name:"Morne Abricot"},
                    {name:"Morne Escarpe"},
                    {name:"Morne Honore"},
                    {name:"Morne Pavillon"},
                    {name:"Morne Roches"},
                    {name:"Morne Vent"},
                    {name:"Pain Bis"},
                    {name:"Perrine"},
                    {name:"Petit Coton"},
                    {name:"Plat Peyi"},
                    {name:"Poirier"},
                    {name:"Pomare"},
                    {name:"Pont Madeleine"},
                    {name:"Prefontaine"},
                    {name:"Ravine Acajou"},
                    {name:"Ravine Braie"},
                    {name:"Regale"},
                    {name:"Regale Renee"},
                    {name:"Rivage"},
                    {name:"Rodalie"},
                    {name:"Rollin"},
                    {name:"Saint Pont"},
                    {name:"Saint Vincent"},
                    {name:"Vieille Citerne"},
                    {name:"Vieilles Terres"},
                    {name:"Vignette"},
              {name:"Autre"},

          ] },
          { name: 'Saint Esprit', adresse2s: [
                    {name:"7 Croisees"},
                    {name:"Baldara"},
                    {name:"Bellay"},
                    {name:"Bois Blanc"},
                    {name:"Bontemps la Cour"},
                    {name:"Bourg"},
                    {name:"Centre ville"},
                    {name:"David"},
                    {name:"Dieuzede"},
                    {name:"Duchatel"},
                    {name:"Firmin"},
                    {name:"Fonds Coulisses"},
                    {name:"Fontenay"},
                    {name:"Four A Chaux"},
                    {name:"Gd Bassin Grosse Roche"},
                    {name:"Gogo"},
                    {name:"Grand Bassin"},
                    {name:"Grand Case"},
                    {name:"la Capoul"},
                    {name:"La Carreau"},
                    {name:"la Ferme"},
                    {name:"la LE ROBERT"},
                    {name:"la Nau"},
                    {name:"la Suin"},
                    {name:"Laboissiere"},
                    {name:"Lannuquette"},
                    {name:"le Coin"},
                    {name:"l'Avenir"},
                    {name:"Mathilde"},
                    {name:"Morne Babet"},
                    {name:"Morne Degras"},
                    {name:"Morne la Croix"},
                    {name:"Morne Lavaleur"},
                    {name:"Morne Vent"},
                    {name:"Nicolas"},
                    {name:"Palmene"},
                    {name:"Peters Maillet"},
                    {name:"Petit Paradis"},
                    {name:"Placide"},
                    {name:"Pointe Royale"},
                    {name:"Presqu Ile"},
                    {name:"Regale Beauplan"},
                    {name:"Regale Fond la Pierre"},
                    {name:"Regale Modere"},
                    {name:"Rivire Moquette"},
                    {name:"Roussane"},
                    {name:"Saint Ange"},
                    {name:"Solitude"},
                    {name:"Suffin"},
                    {name:"Terres Gueydon"},
                    {name:"Thibault"},
                    {name:"Valatte"},
                    {name:"Vieille Citerne"},
              {name:"Autre"},

          ] },
          { name: 'Saint Joseph', adresse2s: [
                    {name:"Belle Etoile"},
                    {name:"Bois du parc"},
                    {name:"Bois Neuf"},
                    {name:"Bourg"},
                    {name:"Centre ville"},
                    {name:"Chapelle"},
                    {name:"Choco"},
                    {name:"Choisy"},
                    {name:"croix z'abricot"},
                    {name:"durant"},
                    {name:"fond cacao"},
                    {name:"Fonds Epingles"},
                    {name:"Gondeau"},
                    {name:"goureau"},
                    {name:"Hermitage lacroix"},
                    {name:"Horizon 2000"},
                    {name:"Hotel des plaisirs"},
                    {name:"long bois"},
                    {name:"Morne des Olives"},
                    {name:"Petit berry"},
                    {name:"Presqu Ile"},
                    {name:"rabuchon"},
                    {name:"riviere blanche"},
                    {name:"rosiere"},
                    {name:"Rousseau"},
                    {name:"salubre"},
                    {name:"seaille"},
                    {name:"Valee heureuse"},
              {name:"Autre"},

          ] },
          { name: 'Saint Pierre', adresse2s: [
                    {name:"Bourg"},
                    {name:"Centre ville"},
                    {name:"cocotte"},
                    {name:"des 3 Ponts"},
                    {name:"Habitation Plaisance"},
                    {name:"Perinelle"},
                    {name:"Saint James"},
                    {name:"Savane du For"},
              {name:"Autre"},

          ] },
          { name: 'Sainte Anne', adresse2s: [
                    {name:"Anse Michel"},
                    {name:"Bareto"},
                    {name:"Barriere la Croix"},
                    {name:"Belle Languette"},
                    {name:"Belvedere"},
                    {name:"Bourg"},
                    {name:"Cap Cabaret"},
                    {name:"Cap Chevalier"},
                    {name:"Cap Ferre"},
                    {name:"Cap Macre"},
                    {name:"Cassiere"},
                    {name:"Centre ville"},
                    {name:"Creve Cìur"},
                    {name:"Debarcadere"},
                    {name:"Derriere Morne"},
                    {name:"Fond Repos"},
                    {name:"Gautonne"},
                    {name:"la Casse"},
                    {name:"les Anglais"},
                    {name:"les Hauts de Beauregard"},
                    {name:"les Hauts Etages"},
                    {name:"Madet"},
                    {name:"Manon"},
                    {name:"Panorama"},
                    {name:"Pointe Chaudiere"},
                    {name:"Pointe Marin"},
                    {name:"Rabat Joie"},
              {name:"Autre"},

          ] },
          { name: 'Sainte Luce', adresse2s: [
                    {name:"Anse Mabouya"},
                    {name:"Bastopol"},
                    {name:"Beaulieu"},
                    {name:"Bellay"},
                    {name:"Bellevue Ladour"},
                    {name:"Belvedere"},
                    {name:"Beola"},
                    {name:"Bernard"},
                    {name:"Blanchard"},
                    {name:"Bourg"},
                    {name:"Centre ville"},
                    {name:"Ceron"},
                    {name:"Corps de Garde"},
                    {name:"Delivry"},
                    {name:"delivry"},
                    {name:"Desert"},
                    {name:"Deville"},
                    {name:"Epinay"},
                    {name:"Grand Figue"},
                    {name:"Gros Raisins"},
                    {name:"Jacques"},
                    {name:"la Croix"},
                    {name:"la Disjonslee"},
                    {name:"Lavison"},
                    {name:"les Coteaux"},
                    {name:"l'Epinay"},
                    {name:"mondesir"},
                    {name:"Monesie"},
                    {name:"Mont Caraibe"},
                    {name:"Montravail"},
                    {name:"Morne des Peres"},
                    {name:"Oblot"},
                    {name:"Petit Fond"},
                    {name:"Trois Rivires"},
                    {name:"Trou au Diable"},
                    {name:"Vezieres"},
                    {name:"Volcart"},
                    {name:"Voleau"},
              {name:"Autre"},

          ] },
          { name: 'Sainte Marie', adresse2s: [
                    {name:"Anso"},
                    {name:"Bagou"},
                    {name:"Bassin Noir"},
                    {name:"Belvedere"},
                    {name:"Bezaudin"},
                    {name:"Bois Jade"},
                    {name:"Bon Air"},
                    {name:"Bonneau"},
                    {name:"Bourg"},
                    {name:"Cadran"},
                    {name:"Centre ville"},
                    {name:"Chataigne France"},
                    {name:"Chertine"},
                    {name:"Citron"},
                    {name:"Clauzel"},
                    {name:"Debarcadere"},
                    {name:"Duchamp"},
                    {name:"Epineux"},
                    {name:"Eudorcait"},
                    {name:"eudorsaix"},
                    {name:"fourniol"},
                    {name:"la Bambouseraie"},
                    {name:"la Capoul"},
                    {name:"la Charmeuse"},
                    {name:"La Regale"},
                    {name:"Lagrosilliere"},
                    {name:"Lassalle"},
                    {name:"Lucon"},
                    {name:"Macroix"},
                    {name:"Maziere"},
                    {name:"Morne des esses"},
                    {name:"Morne Elie"},
                    {name:"Mornes A Roches"},
                    {name:"Mounzy"},
                    {name:"Perou"},
                    {name:"Plaisance"},
                    {name:"p_rou robin"},
                    {name:"Ransay"},
                    {name:"Reculee"},
                    {name:"Rivire Canaris"},
                    {name:"Rivire Romanet"},
                    {name:"Robin"},
                    {name:"Rodon"},
                    {name:"saint jacques"},
                    {name:"Saint Laurent"},
                    {name:"Spourtoune"},
                    {name:"St Aroman"},
                    {name:"Tenos"},
                    {name:"Trou Mangouste"},
                    {name:"villeneuve"},
              {name:"Autre"},

          ] },
          { name: 'Schoelcher', adresse2s: [
                    {name:"Anse collat"},
                    {name:"Anse Gourault"},
                    {name:"Anse Madame"},
                    {name:"Bassignac"},
                    {name:"Batelire"},
                    {name:"Batterie"},
                    {name:"Beauregard"},
                    {name:"Bourg"},
                    {name:"case navire"},
                    {name:"Centre ville"},
                    {name:"Cite st Georges"},
                    {name:"enclos"},
                    {name:"Fond bateliere"},
                    {name:"Fond bernier"},
                    {name:"Fonds Duclos"},
                    {name:"Fonds lahaye"},
                    {name:"Fonds Nigaud"},
                    {name:"Gros Raisins"},
                    {name:"les hauts de madiana"},
                    {name:"Madiana"},
                    {name:"Morne Pavillon"},
                    {name:"plateau fofo"},
                    {name:"pointe de jaham"},
                    {name:"ravine touza"},
                    {name:"saint georges"},
                    {name:"terreville"},
              {name:"Autre"},
  ] },
        ],
      },
      {
        name: 'Guadeloupe',
        villes: [
          { name: 'Les Abymes', adresse2s: [] },
          { name: 'Anse-Bertrand', adresse2s: [] },
          { name: 'Baie-Mahault', adresse2s: [] },
          { name: 'Baillif', adresse2s: [] },
          { name: 'Basse-Terre', adresse2s: [] },
          { name: 'Bouillante', adresse2s: [] },
          { name: 'Capesterre-Belle-Eau', adresse2s: [] },
          { name: 'Capesterre-de-Marie-Galante', adresse2s: [] },
          { name: 'Deshaies', adresse2s: [] },
          { name: 'La Désirade', adresse2s: [] },
          { name: 'Le Gosier', adresse2s: [] },
          { name: 'Gourbeyre', adresse2s: [] },
          { name: 'Goyave', adresse2s: [] },
          { name: 'Grand-Bourg', adresse2s: [] },
          { name: 'Lamentin', adresse2s: [] },
          { name: "Morne-à-l'Eau", adresse2s: [] },
          { name: 'Le Moule', adresse2s: [] },
          { name: 'Petit-Bourg', adresse2s: [] },
          { name: 'Petit-Canal', adresse2s: [] },
          { name: 'Pointe-à-Pitre', adresse2s: [] },
          { name: 'Pointe-Noire', adresse2s: [] },
          { name: 'Port-Louis', adresse2s: [] },
          { name: 'Saint-Claude', adresse2s: [] },
          { name: 'Saint-François', adresse2s: [] },
          { name: 'Saint-Louis', adresse2s: [] },
          { name: 'Sainte-Anne', adresse2s: [] },
          { name: 'Sainte-Rose', adresse2s: [] },
          { name: 'Terre-de-Bas', adresse2s: [] },
          { name: 'Terre-de-Haut', adresse2s: [] },
          { name: 'Trois-Rivières', adresse2s: [] },
          { name: 'Vieux-Fort', adresse2s: [] },
          { name: 'Vieux-Habitants', adresse2s: [] },
        ],
      },
      {
        name: 'Guyane',
        villes: [
          { name: 'Apatou', adresse2s: [] },
          { name: 'Awala-Yalimapo', adresse2s: [] },
          { name: 'Camopi', adresse2s: [] },
          { name: 'Cayenne', adresse2s: [] },
          { name: 'Grand-Santi', adresse2s: [] },
          { name: 'Iracoubo', adresse2s: [] },
          { name: 'Kourou', adresse2s: [] },
          { name: 'Macouria', adresse2s: [] },
          { name: 'Mana', adresse2s: [] },
          { name: 'Maripasoula', adresse2s: [] },
          { name: 'Matoury', adresse2s: [] },
          { name: 'Montsinéry-Tonnegrande', adresse2s: [] },
          { name: 'Ouanary', adresse2s: [] },
          { name: 'Papaïchton', adresse2s: [] },
          { name: 'Régina', adresse2s: [] },
          { name: 'Rémire-Montjoly', adresse2s: [] },
          { name: 'Roura', adresse2s: [] },
          { name: 'Saint-Élie', adresse2s: [] },
          { name: "Saint-Georges-de-l'Oyapock", adresse2s: [] },
          { name: 'Saint-Laurent-du-Maroni', adresse2s: [] },
          { name: 'Saül', adresse2s: [] },
          { name: 'Sinnamary', adresse2s: [] },
        ],
      },
      {name:'Réunion',
    villes:[
       {name :"Les Avirons", adresse2s:[]},
                              {name :"Bras-Panon", adresse2s:[]},
                              {name :"Cilaos", adresse2s:[]},
                              {name :"Entre-Deux", adresse2s:[]},
                              {name :"L'Étang-Salé ", adresse2s:[]},
                              {name :"Petite-Île", adresse2s:[]},
                              {name :"La Plaine-des-Palmistes", adresse2s:[]},
                              {name :"Le Port", adresse2s:[]},
                              {name :"La Possession", adresse2s:[]},
                              {name :"Saint-André", adresse2s:[]},
                              {name :"Saint-Benoît", adresse2s:[]},
                              {name :"Saint-Denis", adresse2s:[]},
                              {name :"Sainte-Marie", adresse2s:[]},
                              {name :"Sainte-Rose", adresse2s:[]},
                              {name :"Sainte-Suzanne", adresse2s:[]},
                              {name :"Saint-Joseph", adresse2s:[]},
                              {name :"Saint-Leu", adresse2s:[]},
                              {name :"Saint-Louis", adresse2s:[]},
                              {name :"Saint-Paul", adresse2s:[]},
                              {name :"Saint-Philippe", adresse2s:[]},
                              {name :"Saint-Pierre", adresse2s:[]},
                              {name :"Salazie", adresse2s:[]},
                              {name :"Le Tampon", adresse2s:[]},
                              {name :"Les Trois-Bassins", adresse2s:[]},

    ]},
    {
      name:'France Hexagonale',
      villes:[]
    }
    ];

  private cookiesIsAcceptedSubject: BehaviorSubject<boolean|null>;
  public  cookiesIsAccepted: Observable<boolean|null>;
  constructor(
    private authenticationService:AuthenticationService,
    private http: HttpClient,
    private _sanitizer: DomSanitizer,
    private rendererFactory: RendererFactory2,
    private meta: Meta,
    private titleService:Title
  ) {
    this.cookiesIsAcceptedSubject = new BehaviorSubject<boolean|null>(null);
    this.cookiesIsAccepted = this.cookiesIsAcceptedSubject.asObservable();
      // Get an instance of Renderer2
      this.renderer = this.rendererFactory.createRenderer(null, null);
    this.subscriptions.push(
      this.authenticationService.currentUser.subscribe(async (x) => {
        this.currentUser = x;
      }));

  }

  CookiesAccept(){
    sessionStorage.setItem('cookiesAccepted','1')
    this.cookiesIsAcceptedSubject.next(true);
  }
  CookiesReject(){
    sessionStorage.setItem('cookiesAccepted','0')
    this.cookiesIsAcceptedSubject.next(false);
  }
  checkCookiesIsAccepted(){
    this.cookiesIsAcceptedSubject.next(sessionStorage.getItem('cookiesAccepted') ? parseInt(sessionStorage.getItem('cookiesAccepted')) == 1 : null)
    return sessionStorage.getItem('cookiesAccepted')
  }

  addPanier(annonce:Annonce){
    //verify if the annonce is already in the panier
    if(!_.find(this.panier, a => a.id == annonce.id))
        this.panier.push(annonce);


  }
  async  generateToken() {
    // Generate a random number and convert it to a hexadecimal string
    const randomValue = crypto.getRandomValues(new Uint32Array(1))[0].toString(16);

    // Get the current timestamp and convert it to a hexadecimal string
    const timestamp = Date.now().toString(16);

    // Combine the random value and timestamp and hash it using SHA-1
    const buffer = new TextEncoder().encode(randomValue + timestamp);
    const hashBuffer = await crypto.subtle.digest('SHA-1', buffer);
    const token = Array.from(new Uint8Array(hashBuffer)).map(byte => byte.toString(16).padStart(2, '0')).join('');

    return token;
  }


  removeExternalStyles(theme) {
    // remove tags in all dom elements with attribute "theme=theme"
    let elements = document.getElementsByTagName('link');
    for (let i = 0; i < elements.length; i++) {
      let element = elements[i];
      // has attributes
        // console.log('element.hasAttribute("theme")',element.hasAttribute('theme'))
      if (element.hasAttribute('theme') && element.getAttribute('theme') !== theme) {
        // alert('Theme : ' + element.getAttribute('theme'))
        // remove DOM elemeent
        // element.remove();
        const items:any = document.querySelectorAll("link[theme="+element.getAttribute('theme')+"]");
        // console.log('removeExternalStyles items',items)
        for (let item of items) {
             item.remove();
        }
      }
    }

  }
  updateMetaTags(metaTags) {
    // Update og:title
    if(metaTags.title){

    // Update <title> tag
    this.titleService.setTitle(metaTags.title);
    this.meta.updateTag({ property: 'og:title', content: metaTags.title });
    }

    // Update og:description
    if(metaTags.description){

    this.meta.updateTag({ property: 'description', content: metaTags.description });
    this.meta.updateTag({ property: 'og:description', content: metaTags.description });
    }

    if(metaTags.url)
    this.meta.updateTag({ property: 'og:url', content: metaTags.url });
    if(metaTags.image)
    this.meta.updateTag({ property: 'og:image', content: metaTags.image });

    // You can similarly update other meta tags as needed
  }
  loadExternalStyles(el, url: string,theme?) {
    if(theme)
    this.removeExternalStyles(theme);
    // foreach tag link in dom elements, if same url is not present, add tag link type text/css, rel="stylesheet" and href=url
    let canAdd = true;
    let links =  document.getElementsByTagName('link');
    for (let i = 0; i < links.length; i++) {
      let link = links[i];
      if (link.href.indexOf(url) > -1) {
        canAdd = false
      }
    }


    if(canAdd){
    const head = this.renderer.parentNode(el.nativeElement);
    const style = this.renderer.createElement('link');
    this.renderer.setAttribute(style, 'rel', 'stylesheet');
    this.renderer.setAttribute(style, 'type', 'text/css');
    this.renderer.setAttribute(style, 'href', url);
    if(theme)
    this.renderer.setAttribute(style, 'theme', theme);
    this.renderer.appendChild(head, style);

  }
  }

  hasRoles(rolesToSearch,roles?) {
    // console.log('hasRoles',rolesToSearch,roles,this.currentUser?.roles)
    if(!roles)
    roles = this.currentUser?.roles
    return (
      _.find(rolesToSearch, (r) =>
        _.find(roles, (ur) => {
          if(ur.childrens?.length)
          return ur.role.indexOf(r) === 0 || this.hasRoles(rolesToSearch,ur.childrens)
          else
          return ur.role.indexOf(r) === 0
        })
      ) != null
    );
  }
  // custom validator to check that two fields match
  MustMatch(controlName: string, matchingControlName: string) {
      return (formGroup: UntypedFormGroup) => {
          const control = formGroup.controls[controlName];
          const matchingControl = formGroup.controls[matchingControlName];

          if (matchingControl.errors && !matchingControl.errors.mustMatch) {
              // return if another validator has already found an error on the matchingControl
              return;
          }

          // set error on matchingControl if validation fails
          if (control.value !== matchingControl.value) {
              matchingControl.setErrors({ mustMatch: true });
          } else {
              matchingControl.setErrors(null);
          }
      }
  }

  // withPrevision(){
  //   return environment.withPrevision ;
  // }

  convertImageToBase64(imagePath: string): Promise<string> {
    return new Promise((resolve, reject) => {
    this.http.get(imagePath, { responseType: 'blob' })
      .subscribe(response => {
        this.blobToBase64(response)
          .then(base64Image => {
            // console.log(base64Image); // Output the Base64 string.
            resolve(base64Image);
          })
          .catch(error => {
            console.error('Error converting image to Base64:', error);
            reject(error);
          });
      });
    })
  }

  blobToBase64(blob: Blob): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result as string;
        resolve(base64String);
      };
      reader.onerror = () => {
        reject(reader.error);
      };
      reader.readAsDataURL(blob);
    });
  }

  getBackground(src) {
    // console.log('src',src)
      return this._sanitizer.bypassSecurityTrustStyle(
        "url(" + src + ")"
      );
  }


  displayExprFn(data, displayExpr) {
    // console.log(data);
    // if (
    //   this.options.data[this.name] &&
    //   (data == this.options.data[this.name][this.valueExpr] ||
    //     (isObject(data) &&
    //       data['id'] == this.options.data[this.name][this.valueExpr]))
    // ) {
    //   data = this.options.data[this.name];
    // }
    let display = '';
    if (displayExpr) {
      let listExpr = displayExpr.split(',');
      let withoutTrait = false;
      _.each(listExpr, (expr, i) => {
        let d;
        if (expr == '<br>') {
          d = '<br/>';
          withoutTrait = true;
        } else {
          d = data ? expr.split('.').reduce(this.index, data) : '';
          if (i > 0 && display && d && !withoutTrait) {
            display += ' - ';
          }
          // console.log('d',i, d,display)

          withoutTrait = false;
        }
        display += d;
        // if(!d)
        //   withoutTrait = true;
      });
    }
    return display;
  }

  index(obj, i) {
    if (obj[i]) return obj[i];
    else return '';
  }
  currencyFormat(number){
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(number);
  }
  validatePhonenumber(inputtxt) {
    var phoneno = /^\d{10}$/;
    if (inputtxt.match(phoneno)) {
      return true;
    } else {
      return false;
    }
  }
  validateEmail(email) {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  }
   getJourList(){
    let list = [];
    for (let i = 1; i <= 31; i++) {
      list.push(i);
    }
    return list;
  }

  getMoisListInCurrentLocale(){
    // return months in text in current locale
    let list = [];
    for (let i = 1; i <= 12; i++) {
      list.push({index:i, mois:this.getMoisText(i)});
    }
    return list;
  }

  getMoisText = (month: number) => {
    // in current locale
    return new Date(new Date().getFullYear(), month, 1).toLocaleString('fr-FR',{ month:'long' });
  }

  getAnneeList(){
    let list = [];
    for (let i = 1; i <= 100; i++) {
      list.push(new Date().getFullYear() - 18 - i);
    }
    return list;
  }

  getFormatTime(time)
  {
    // return time in format HH:mm:ss
    let minutes = Math.floor(time / 60 );
    let secondes = Math.round(time % 60);
    return ( minutes > 0 ? (minutes < 10? '0' + minutes : minutes) + ' minute(s) et ' : '') + (secondes < 10? '0' + secondes : secondes)+ ' seconde(s)';
  }

}
